


function SummaryCards({
    MyExpenses = 0,
    MyGroups = 0,
    billsSplit = 0,
    MyDebts = 0
  }) {
    return (
      <div className="row g-3 mb-4 ">
        <div className="col-12 col-sm-6 col-md-3 mb-3">
          <div className="card border-0 summary-card text-center">
            <div className="h4 mb-1">{MyExpenses.toLocaleString()}</div>
            <div className="text-muted">My Expenses</div>
            <div className="text-success mt-1" style={{ fontSize: "1.5rem" }}>🧾</div>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-md-3 mb-3">
          <div className="card border-0 summary-card text-center">
            <div className="h4 mb-1">{MyGroups}</div>
            <div className="text-muted">My Groups</div>
            <div className="text-primary mt-1" style={{ fontSize: "1.5rem" }}>👥</div>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-md-3 mb-3">
          <div className="card border-0 summary-card text-center">
            <div className="h4 mb-1">{billsSplit}</div>
            <div className="text-muted">Bills Split</div>
            <div className="text-warning mt-1" style={{ fontSize: "1.5rem" }}>💸</div>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-md-3 mb-3">
          <div className="card border-0 summary-card text-center">
            <div className="h4 mb-1">{MyDebts}</div>
            <div className="text-muted">Debts Owed to Me</div>
            <div className="text-warning mt-1" style={{ fontSize: "1.5rem" }}>💰</div>
          </div>
        </div>
      </div>
    );
  }
  
  export default SummaryCards;